import { render, staticRenderFns } from "./IndexDialog.vue?vue&type=template&id=13f0aea2&scoped=true&"
import script from "./IndexDialog.vue?vue&type=script&lang=js&"
export * from "./IndexDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f0aea2",
  null
  
)

export default component.exports